import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DashboardTitlePaper = styled(Paper)(
    ({ theme }) => ({
        [theme.breakpoints.up('xs')]: {
            padding: theme.spacing(2),
            '& .user-avatar': {
                height: '75px',
                width: '75px'
            }
        },
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(3),
            '& .user-avatar': {
                height: '85px',
                width: '85px'
            }
        },
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(3),
            '& .user-avatar': {
                height: '100px',
                width: '100px'
            }
        },
        [theme.breakpoints.up('lg')]: {
            padding: theme.spacing(4),
            '& .user-avatar': {
                height: '100px',
                width: '100px'
            }
        },
        width: '100%',
        borderRadius: 15,
        
    })
);

export const DashboardDraftJobsPaper = styled(Paper)(
    ({ theme }) => ({
        [theme.breakpoints.up('xs')]: {
            padding: theme.spacing(2),
        },
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(3),
        },
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(3),
        },
        [theme.breakpoints.up('lg')]: {
        },
        width: '100%',
        borderRadius: 15,
        })
);

export const boxStyles = {
    padding: 4,
    border: '1px solid rgba(0, 0, 0, 0.1)',
    borderRadius: 6,
    textDecoration: 'none',
    '&:hover': { background: '#DFE8F6' },
    '& svg': { transform: 'scale(1.5)' },
};


export const jobBoxStyles = {
    padding: 2,
    border: '1px solid rgba(0, 0, 0, 0.1)', 
    borderRadius: 4,
    textDecoration: 'none',
    '&:hover': { background: '#DFE8F6' },
};
